export const travelXNewFeatureKey = 'travelxNew';
